export const travelXNewFeatureKey = 'travelxNew';
